import PrimaryCell from "../../../../../../ui/Table/Cells/PrimaryCell";
import {RequestStateCell} from "../../../../../../ui/QueryTable/Cell/RequestProgramStatus";
import LinkCell from "./LinkCell";

export const columns = [
  {
    dataField: "id",
    caption: "ID",
    dataType: "string",
    cellRender: LinkCell,
    width: 68
  },
  {
    dataField: "date",
    caption: "Дата",
    dataType: "date",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "programName",
    caption: "Программа",
    dataType: "string",
    cellRender: PrimaryCell,
  },
  {
    dataField: "name",
    caption: "ФИО заявителя",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "email",
    caption: "Email заявителя",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "studentName",
    caption: "ФИО обучающегося",
    dataType: "string",
    cellRender: PrimaryCell
  },
  {
    dataField: "studentBirthDate",
    caption: "Дата рождения обучающегося",
    dataType: "string",
    cellRender: PrimaryCell,
    width: 100
  },
  {
    dataField: "status",
    caption: "Статус",
    dataType: "integer",
    cellRender: RequestStateCell,
    width: 64
  }];
